import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import HeroSection from './components/HeroSection';
import WhatIsSection from './components/WhatIsSection';
import BenefitsSection from './components/BenefitsSection';
import CategoriesSection from './components/CategoriesSection';
import HowItWorksSection from './components/HowItWorksSection';
import SafetySection from './components/SafetySection';
import CTASection from './components/CTASection';
import ArticleSection from './components/ArticleSection';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://kakobuyfinds.buzz';

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Kakobuy Finds',
    url: siteUrl,
    description: 'Discover the best Kakobuy Spreadsheet with thousands of product finds, category guides, comparison tools, and shopping resources.',
    inLanguage: 'en-US',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${siteUrl}/search?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <JsonLd data={jsonLd} />
      <Navbar />
      <main>
        <article>
          <HeroSection />
          <WhatIsSection />
          <BenefitsSection />
          <CategoriesSection />
          <HowItWorksSection />
          <SafetySection />
          <CTASection />
          <ArticleSection />
        </article>
      </main>
      <Footer />
    </>
  );
}